export enum Currency {
  Eur = 'EUR',
  Czk = 'CZK',
}
